



























































import debounce from 'lodash/debounce';
import {
  getAvailableUserPromoCampaigns,
  giveReward
} from '@/api/PromoCampaign';
import { errorToastMessage } from '@/helpers/errorToastMessage';

import type { PromoCampaignByUser } from '@/api/schema';

export default {
  name: 'UserManagementPromoCampaignAddDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      required: true
    },
    operatorUserId: {
      type: String,
      default: (): string => null
    }
  },
  data: (): any => ({
    campaigns: [],
    selected: null,
    search: null,
    query: null,
    loading: false,
    saving: false
  }),
  computed: {
    items(): PromoCampaignByUser[] {
      return this.campaigns;
    },
    isDisabledAddBtn(): boolean {
      return !this.selected || this.saving;
    }
  },
  watch: {
    value(opened: boolean): void {
      if (!opened) return;

      this.selected = null;
      this.search = null;
      this.getCampaigns('');
    },
    search(value: string | null): void {
      const query = value ?? '';

      if (query === this.query) return;

      this.debouncedGetCampaigns(query);
    }
  },
  created(): void {
    this.debouncedGetCampaigns = debounce(this.getCampaigns, 300);
  },
  methods: {
    campaignTitle({ id, name }: PromoCampaignByUser): string {
      return `#${id} ${name}`;
    },
    getCampaigns(query: string): Promise<unknown> {
      this.query = query;
      this.loading = true;

      return getAvailableUserPromoCampaigns(this.userId, query)
        .then((data: PromoCampaignByUser[]): void => {
          this.campaigns = data;
        })
        .catch(errorToastMessage)
        .finally((): void => {
          this.loading = false;
        });
    },
    submit(): Promise<unknown> {
      this.saving = true;

      return giveReward(this.selected.id, this.operatorUserId)
        .then((): void => {
          this.$toast.success('User has been added to the promo campaign');
          this.$emit('added');
          this.closeAction();
        })
        .catch(errorToastMessage)
        .finally((): void => {
          this.saving = false;
        });
    },
    closeAction(): void {
      this.$emit('close');
    }
  }
};
